import React from 'react';
import noop from 'lodash/noop';
import { Flex, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { useEpicIssueTypeName } from '@atlassian/jira-backlog-epics-store/src/selectors/index.tsx';
import Panel from '../../../../common/ui/panel/main.tsx';
import { CreateEpicButton } from '../main.tsx';
import type { Props } from '../../main.tsx';

type LoadingSkeletonProps = Pick<Props, 'canCreate' | 'hierarchyName'>;

export const LoadingSkeleton = ({ canCreate, hierarchyName }: LoadingSkeletonProps) => {
	const [epicIssueTypeName] = useEpicIssueTypeName();

	return (
		<Panel title={epicIssueTypeName} onClose={noop}>
			<Flex alignItems="center" justifyContent="center" xcss={loadingWrapper}>
				<Spinner size="medium" />
			</Flex>
			<CreateEpicButton
				isCreateEnabled={Boolean(canCreate)}
				hierarchyName={hierarchyName}
				onCreateEpic={noop}
				onCreateCMPEpic={noop}
			/>
		</Panel>
	);
};

const loadingWrapper = xcss({
	paddingBlock: 'space.600',
});
